var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.cc.id == 'centrobill')?_c('ui-cc-centrobill',{ref:"centrobill",on:{"token":_vm.token}}):(_vm.cc.id == 'stripe')?_c('ui-cc-stripe',{ref:"stripe",attrs:{"amount":_vm.amount,"message":_vm.message},on:{"token":_vm.token}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }